var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModaltitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16699 11.0833H19.0003V26.9167H3.16699V11.0833ZM15.8337 23.75V14.25H6.33366V23.75H15.8337ZM34.8337 11.0833H22.167V14.25H34.8337V11.0833ZM22.167 17.4167H34.8337V20.5833H22.167V17.4167ZM34.8337 23.75H22.167V26.9167H34.8337V23.75Z",
    fill: "#E4002B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModaltitle);
export default __webpack_public_path__ + "static/media/modaltitle.06e0769be17046e266301f422b074773.svg";
export { ForwardRef as ReactComponent };